<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <div class="response-container">
      <h1>FASTAG 01 API Response</h1>
      <b-row>
        <b-col md="3">
          <label>Vehicle No(CG07BC9186)</label>
          <model-list-select
            :list="$store.getters['commonDropdownMaster/getAllVehicleDDList']"
            v-model="vehiclenumber"
            option-value="label"
            option-text="label"
            placeholder="Select Vehicle No"
          ></model-list-select>

          <!-- @input="getAllFASTAG01Func()" -->
        </b-col>
        <b-col md="3">
          <b-button
            v-if="vehiclenumber"
            @click="getAllFASTAG01Func()"
            size="sm"
            variant="info"
            style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px"
            >Fetch</b-button
          >
        </b-col>
      </b-row>
      <b-row
        ><b-col md="12" v-if="getAllFASTAG01.length > 0">
          <div
            v-if="
              getAllFASTAG01.length <= 0 ||
              getAllFASTAG01[0].responseStatus === 'not found'
            "
          >
            <p>No data found.</p>
          </div>
          <div v-else>
            <b-row>
              <b-col md="12" class="mt-1 mb-1">
                <strong>Response Status:</strong> {{ getAllFASTAG01[0].response.result }}
              </b-col>
              <b-col md="12" class="mt-1 mb-1">
                <strong>Response Code:</strong> {{ getAllFASTAG01[0].response.respCode }}
              </b-col>
              <b-col md="12" class="mt-1 mb-1">
                <strong>Timestamp:</strong> {{ getAllFASTAG01[0].response.ts }}
              </b-col>
            </b-row>
            <div v-if="getAllFASTAG01[0].response.result !== 'FAILED'">
              <b-row
                v-for="(txn, index) in getAllFASTAG01[0].response.vehicle.vehltxnList.txn"
                :key="index"
                class="mt-2"
              >
                <b-col md="12" class="mb-1">
                  <h5>Transaction {{ index + 1 }}</h5>
                </b-col>
                <b-col md="6" class="mb-1">
                  <strong>Reader Read Time:</strong> {{ txn.readerReadTime }}
                </b-col>
                <b-col md="6" class="mb-1">
                  <strong>Sequence Number:</strong> {{ txn.seqNo }}
                </b-col>
                <b-col md="6" class="mb-1">
                  <strong>Lane Direction:</strong> {{ txn.laneDirection }}
                </b-col>
                <b-col md="6" class="mb-1">
                  <strong>Toll Plaza Geocode:</strong> {{ txn.tollPlazaGeocode }}
                </b-col>
                <b-col md="6" class="mb-1">
                  <strong>Toll Plaza Name:</strong> {{ txn.tollPlazaName }}
                </b-col>
                <b-col md="6" class="mb-1">
                  <strong>Vehicle Type:</strong> {{ txn.vehicleType }}
                </b-col>
                <b-col md="6" class="mb-1">
                  <strong>Vehicle Registration Number:</strong> {{ txn.vehicleRegNo }}
                </b-col>
              </b-row>
            </div>
          </div></b-col
        ></b-row
      >
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import UlipService from "../../services/UlipService.js";
import CustomLoader from "../common/customLoader.vue";
import { globalPermissionStatus } from "../../helper/collection";
export default {
  beforeMount() {
    this.$store.dispatch(
      "commonDropdownMaster/setAllVehicleDDList",
      JSON.stringify({
        itemCode: "getVehicleList",
        vehicleActiveInactiveId: "1",
      })
    );
    this.$store.dispatch("setCurrentRoute", this.$route.path);
    if (globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP")) {
      // this.getAllFASTAG01Func();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      vehiclenumber: "",
      getAllFASTAG01: [],
      isLoading: false,
      error: false,
      code: 200,
      message: "Success",
    };
  },

  filters: {},

  mounted() {},

  beforeDestroy() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
  },

  methods: {
    async getAllFASTAG01Func() {
      let payload = {};
      this.isLoading = true;
      this.getAllFASTAG01 = [];

      if (this.vehiclenumber) {
        payload = {
          itemCode: "FASTAG01",
          funcUrl: "FASTAG/01",
          vehiclenumber: this.vehiclenumber,
        };

        payload = JSON.stringify(payload);
        UlipService.getAllUlipList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data && data.getAllFASTAG01) {
              if (
                data.getAllFASTAG01 &&
                data.getAllFASTAG01.response &&
                data.getAllFASTAG01.response.response &&
                data.getAllFASTAG01.response.response.length > 0
              ) {
                this.getAllFASTAG01 = data.getAllFASTAG01.response.response;
              }
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on getAllFASTAG01 Error: ", error);
          });
      }
    },
  },
};
</script>

<style scoped>
.response-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
  font-size: 18px;
}

strong {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// FASTAG_ResponseDisplay.vue?69396b4e